import _ from 'lodash';
import platformUtils from 'platformUtils';
import reporter from 'privates/reporter';
import {generateError} from 'privates/validations/errors';
import linkGenerator from 'privates/utils/linkGenerator';
import {validate} from './../validations/validation';
import {GALLERY_ITEM_TYPES} from '../constants';
import {isNilOrEmptyString} from 'privates/utils';

function isValidImage(src) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.IMAGE);
}

function extractModelDataFromSrc(src) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.IMAGE);
    if (parseMediaItem.error) {
        return null;
    }

    return {
        uri: parseMediaItem.mediaId,
        width: parseMediaItem.width,
        height: parseMediaItem.height,
        title: parseMediaItem.title
    };
}

function buildFullUrlFromMediaRef(mediaRef) {
    return buildFullUrlFromUri(mediaRef.uri, mediaRef.width, mediaRef.height, mediaRef.title);
}

function convertImageToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    const imageData = extractModelDataFromSrc(src);
    _.assign(imageData, {type: 'Image'});
    if (!imageData) {
        const error = !_.isNil(index) ? generateError.error_bad_image_format_with_index : generateError.error_bad_image_format;
        reporter.reportSdkError(error({
            propertyName,
            functionName,
            index,
            wrongValue: src
        }));
        return null;
    }
    return imageData;
}

function buildFullUrlFromUri(uri, width, height, title) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const mediaItemUri = mediaSrcHandler.createMediaSrc({mediaId: uri, type: mediaSrcHandler.types.IMAGE, width, height, title});
        if(mediaItemUri.error) {
            return '';
        }
    return mediaItemUri.item;
}

function convertModelToUserFormat(imageData) {
    const height = _.isUndefined(imageData.height) ? imageData.height : Number(imageData.height);
    const width = _.isUndefined(imageData.width) ? imageData.width : Number(imageData.width);
    const title = imageData.title;
    const src = buildFullUrlFromUri(imageData.uri || imageData.src, width, height, title);
    const result = _.omitBy({
        type: imageData.type,
        description: imageData.description,
        alt: imageData.alt,
        title,
        height,
        width,
        link: linkGenerator.convertLinkToUrlAndReportIfError(imageData.link, imageData.target, 'items'),
        target: _.get(imageData, 'link.target')
    }, _.isUndefined);

    result.src = src;

    return result;
}

function convertUserToModelFormat(imageData, imageIndex) {
    const uri = imageData.uri || imageData.src;
    let dataFromSrc = {};

    if (isNilOrEmptyString(uri)) {
        dataFromSrc.uri = '';
    } else {
        dataFromSrc = convertImageToModelFormatAndReportIfError(uri, 'src', 'items', imageIndex);
        if (!dataFromSrc) {
            return;
        }
    }

    const result = _.omitBy(
        _.defaults({
            type: GALLERY_ITEM_TYPES.image,
            description: imageData.description,
            title: imageData.title,
            alt: imageData.alt,
            id: imageData.id,
            link: linkGenerator.convertLinkToModelFormatAndReportIfError(imageData.link, imageData.target, 'items', imageIndex),
            width: imageData.width,
            height: imageData.height
        }, dataFromSrc),
        _.isUndefined);

    result.uri = dataFromSrc.uri;

    return result;
}

function checkImageValidation({imageData, imageIndex, elementID}) {
    const imageType = 'Image';
    return validate({
        compType: imageType,
        functionName: 'items',
        dataToValidate: imageData,
        shouldCheckMandatoryFields: true,
        itemIndex: imageIndex,
        elementID
    });
}

function filterImageItems(items) {
    return _.filter(items, (item) => {
        return _.isUndefined(item.type) || _.toLower(item.type) === _.toLower(GALLERY_ITEM_TYPES.image);
    });
}

export default {
    isValidImage,
    buildFullUrlFromMediaRef,
    extractModelDataFromSrc,
    buildFullUrlFromUri,
    filterImageItems,
    checkImageValidation,
    convertImageToModelFormatAndReportIfError,
    dataFormat: {
        toUser: convertModelToUserFormat,
        toModel: convertUserToModelFormat
    }
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/imageUtils.es6